import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * «LA WEB ESTÁ EN TU IDIOMA; LAS CANALIZACIONES, TODAVÍA EN ESPAÑOL.»
 *
 * PLAN_IDIOMAS 1.4 (28-ago): quien elige alemán ve el menú en alemán y la
 * pieza en español, sin aviso — y eso es exactamente el tipo de promesa a
 * medias que la regla dura prohíbe. Una línea lo dice, y se retira sola en
 * cuanto ese idioma tenga piezas: hoy ninguno las tiene, así que se enseña
 * siempre que el idioma no sea el español.
 *
 * Se pinta en dos sitios: bajo el mensaje del día en la portada y encima del
 * cuerpo en la ficha. Nunca en el menú ni en el pie: no es un aviso del sitio,
 * es un aviso de ESE texto.
 */
const AvisoIdioma = ({ className = '' }) => {
  const { t, i18n } = useTranslation();
  if ((i18n.language || 'es').startsWith('es')) return null;
  return (
    <Typography className={`aviso-idioma ${className}`.trim()} sx={{
      fontFamily: 'var(--fuente-titulo)', fontSize: '.78rem', letterSpacing: '.04em',
      color: 'var(--texto-tenue)', textAlign: 'center', mt: 1.5, mb: 1
    }}>
      {t('aviso.piezas_en_espanol')}
    </Typography>
  );
};

export default AvisoIdioma;
